<template>
  <section class="old-wrapper">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <el-form-item label="类别名称">
          <el-select
            v-model="filters.type"
            placeholder="请选择"
            @change="chooseCat"
          >
            <el-option
              v-for="(item, index) in catOptions"
              :key="item.cacTypeId"
              :label="item.name"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            plain
            v-on:click="addCata"
            >新建类别</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            icon="el-icon-circle-plus-outline"
            plain
            v-on:click="deleteCata"
            >管理类别</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            icon="el-icon-circle-plus-outline"
            plain
            v-on:click="addType"
            >新建项目</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="typeList"
      highlight-current-row
      v-loading="listLoading"
      :row-style="tableRowStyle"
      :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
      :header-cell-style="tableHeaderColor"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column prop="typeName" label="评估项目" width="350">
      </el-table-column>
      <el-table-column label="评估标准">
        <template slot-scope="scope">
          <div
            v-for="(item, index) in scope.row.cacBaseMinorItemList"
            :key="index"
          >
            <div>
              <p
                v-if="
                  scope.row.type == 2 &&
                  item.instruction != null &&
                  item.instruction.length > 0
                "
              >
                {{ item.grade }} ,{{ item.name }}({{ item.instruction }})
              </p>
              <p v-else-if="scope.row.type == 2">
                {{ item.grade }} ,{{ item.name }}
              </p>
              <p
                v-else-if="
                  item.instruction != null && item.instruction.length > 0
                "
              >
                {{ item.grade }}分 ,{{ item.name }}({{ item.instruction }})
              </p>
              <p v-else>{{ item.grade }}分 ,{{ item.name }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >

                <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="handleDel(scope.$index, scope.row)"
                  >删除</el-button
                >
          <!-- <span
            style="color: #3f7be2; margin-right: 10px; cursor: pointer"
            @click="handleEdit(scope.$index, scope.row)"
            >修改</span
          >
          <span
            style="color: #ff6969; cursor: pointer"
            @click="handleDel(scope.$index, scope.row)"
            >删除</span
          > -->
        </template>
      </el-table-column>
    </el-table>

    <!--新添类别界面-->
    <el-dialog
      title="新增类别"
      :visible.sync="addCatVisible"
      width="500px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        :model="addCataForm"
        label-width="100px"
        :rules="addCataRules"
        ref="addCataForm"
      >
        <el-form-item label="类别名称" prop="name">
          <el-input
            v-model="addCataForm.name"
            auto-complete="off"
            :maxlength="9"
            style="width: 300px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="cancelCataSubmit()">取消</el-button>
        <el-button type="primary" @click.native="addCataSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!--新添加评估项目-->
    <el-dialog
      title="新增评估项目"
      :visible.sync="addTypeVisible"
      :close-on-click-modal="false"
      class="addTypeVisible"
      center
    >
      <el-form
        :model="addTypeForm"
        label-width="100px"
        :rules="addTypeRules"
        ref="addTypeForm"
      >
        <el-row>
          <el-col :span="7">
            <el-form-item label="评估项目:" prop="name">
              <el-input
                v-model="addTypeForm.name"
                :maxlength="12"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="项目说明:" prop="instruction">
              <el-input
                v-model="addTypeForm.instruction"
                :maxlength="45"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目类别:" prop="type">
              <el-select
                v-model="addTypeForm.type"
                @change="selecttype"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in addTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="addTypeItemForm" label-width="0px" ref="addTypeItemForm">
        <el-row style="background: #b5e0ff; height: 36px; margin-bottom: 5px">
          <el-col
            :span="23"
            style="text-align: center; font-size: 15px; padding-top: 8px"
          >
            评估标准
          </el-col>
          <el-col :span="1">
            <i
              style="
                color: red;
                font-size: 20px;
                margin-top: 10px;
                cursor: pointer;
              "
              class="el-icon-circle-plus-outline"
              v-show="sumtype"
              v-on:click="addTypeItem"
            ></i>
          </el-col>
        </el-row>
        <!--表格-->
        <el-form-item
          v-for="(item, index) in addTypeItemForm.addTypeItems"
          :key="index"
        >
          <el-row :gutter="10">
            <el-col :span="1" style="text-align: center; padding-top: 6px">
              <img
                src="@/assets/beadhouse/select_icon.png"
                height="18"
                width="18"
              />
            </el-col>
            <el-col :span="4">
              <el-form-item
                label=" "
                :prop="'addTypeItems.' + index + '.grade'"
                :rules="[{ required: true, message: '请选择分数' }]"
              >
                <el-select
                  v-model="item.grade"
                  placeholder="请选择"
                  style="width: 90px"
                >
                  <el-option
                    v-for="item in tenOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label=" "
                :prop="'addTypeItems.' + index + '.name'"
                :rules="[{ required: true, message: '请输入名称' }]"
              >
                <el-input
                  v-model="item.name"
                  placeholder="请输入名称"
                  :maxlength="100"
                  style="width: 230px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-input
                v-model="item.instruction"
                :maxlength="100"
                placeholder="请输入描述"
              ></el-input>
            </el-col>
            <el-col :span="1">
              <i
                class="el-icon-circle-close"
                style="font-size: 20px; margin-top: 12px; cursor: pointer"
                v-show="sumtype"
                v-on:click="deleteTypeItemindex(index)"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="cancelTypeSubmit">取消</el-button>
        <el-button type="primary" @click.native="addTypeSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!--管理类别-->
    <el-dialog
      title="管理类别"
      width="wrap"
      :visible.sync="guanliDialogVisible"
      :close-on-click-modal="false"
    >
      <el-table
        ref="guanliTable"
        :data="copycatOptions"
        highlight-current-row
        :header-cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column label="类别名称">
          <template slot-scope="scope">
            <el-input
              class="inputGuan"
              ref="input"
              v-model="scope.row.name"
              :maxlength="9"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160px">
          <template slot-scope="scope">
            <el-button size="small" @click="guanliEdit(scope.$index, scope.row)"
              >保存</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="guanliDel(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑评估项目"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="editFormVisible"
      center
    >
      <el-form
        :model="editForm"
        label-width="100px"
        ref="editForm"
        :rules="editTypeRules"
      >
        <el-row>
          <el-col :span="7">
            <el-form-item label="评估项目:" prop="name">
              <el-input
                v-model="editForm.name"
                :maxlength="12"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="项目说明:" prop="instruction">
              <el-input
                v-model="editForm.instruction"
                :maxlength="45"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目类别:" prop="type">
              <el-select
                v-model="editForm.type"
                @change="selectedittype"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in addTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="editForm" label-width="0px" ref="editForm1">
        <el-row style="background: #b5e0ff; height: 36px; margin-bottom: 5px">
          <el-col
            :span="23"
            style="text-align: center; font-size: 15px; padding-top: 8px"
          >
            评估标准
          </el-col>
          <el-col :span="1">
            <i
              style="
                color: red;
                font-size: 20px;
                margin-top: 10px;
                cursor: pointer;
              "
              class="el-icon-circle-plus-outline"
              v-show="sumedittype"
              v-on:click="addEditTypeItem"
            ></i>
          </el-col>
        </el-row>
        <!--表格-->
        <el-form-item
          v-for="(item, index) in editForm.cacBaseMinorItemList"
          :key="index"
        >
          <el-row :gutter="10">
            <el-col :span="1" style="text-align: center; padding-top: 6px">
              <img
                src="@/assets/beadhouse/select_icon.png"
                height="18"
                width="18"
              />
            </el-col>
            <el-col :span="4">
              <el-form-item
                label=" "
                :prop="'cacBaseMinorItemList.' + index + '.grade'"
                :rules="[{ required: true, message: '请选择分数' }]"
              >
                <el-select
                  v-model="item.grade"
                  placeholder="请选择"
                  style="width: 90px"
                >
                  <el-option
                    v-for="item in tenOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label=" "
                :prop="'cacBaseMinorItemList.' + index + '.name'"
                :rules="[{ required: true, message: '请输入名称' }]"
              >
                <el-input
                  v-model="item.name"
                  placeholder="请输入名称"
                  :maxlength="100"
                  style="width: 230px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-input
                v-model="item.instruction"
                :maxlength="100"
                placeholder="请输入描述"
              ></el-input>
            </el-col>
            <el-col :span="1">
              <i
                class="el-icon-circle-close-outline"
                v-show="sumedittype"
                style="font-size: 20px; margin-top: 12px; cursor: pointer"
                v-on:click="deleteEditTypeItemindex(index, item)"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      catName: "",
      filters: {
        type: "",
      },
      currentTypeIndex: 0,
      typeList: [],
      sumtype: true, //添加的显示隐藏
      sumedittype: true, //编辑的删除添加显示与隐藏
      cacTypeId: "", //类型ID
      editbigTypeId: "", //修改的选项ID
      listLoading: false,
      addCatVisible: false, //新添类别
      addTypeVisible: false, //新添项目显示
      guanliDialogVisible: false,
      editFormVisible: false, //编辑评估界面是否显示
      editLoading: false,
      editFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      addCataForm: {
        name: "",
      },
      addTypeForm: {
        name: "", //项目名称
        instruction: "", //描述
        type: "", //表明类别
      },
      addTypeItemForm: {
        addTypeItems: [
          {
            grade: "",
            name: "",
            instruction: "",
          },
        ],
      },
      addTypeOptions: [
        {
          value: 0,
          label: "需要计算的项",
        },
        {
          value: 1,
          label: "类别的总分",
        },
        {
          value: 2,
          label: "类别的等级",
        },
      ],
      holdtenoption: [
        {
          value: 0,
          label: "0分",
        },
        {
          value: 1,
          label: "1分",
        },
        {
          value: 2,
          label: "2分",
        },
        {
          value: 3,
          label: "3分",
        },
        {
          value: 4,
          label: "4分",
        },
        {
          value: 5,
          label: "5分",
        },
        {
          value: 6,
          label: "6分",
        },
        {
          value: 7,
          label: "7分",
        },
        {
          value: 8,
          label: "8分",
        },
        {
          value: 9,
          label: "9分",
        },
        {
          value: 10,
          label: "10分",
        },
        {
          value: 15,
          label: "15分",
        },
        {
          value: 20,
          label: "20分",
        },
      ],
      tenOptions: [
        {
          value: 0,
          label: "0分",
        },
        {
          value: 1,
          label: "1分",
        },
        {
          value: 2,
          label: "2分",
        },
        {
          value: 3,
          label: "3分",
        },
        {
          value: 4,
          label: "4分",
        },
        {
          value: 5,
          label: "5分",
        },
        {
          value: 6,
          label: "6分",
        },
        {
          value: 7,
          label: "7分",
        },
        {
          value: 8,
          label: "8分",
        },
        {
          value: 9,
          label: "9分",
        },
        {
          value: 10,
          label: "10分",
        },
        {
          value: 15,
          label: "15分",
        },
        {
          value: 20,
          label: "20分",
        },
      ],
      addCataRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      addTypeRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        instruction: [
          // {required: true, message: '请输入说明', trigger: 'blur'}   by guo 2019-3-28
        ],
        type: [{ required: true, message: "请选择类别", trigger: "blur" }],
      },
      editTypeRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        instruction: [
          // {required: true, message: '请输入说明', trigger: 'blur'}  by guo 2019-3-28
        ],
        type: [{ required: true, message: "请选择类别", trigger: "blur" }],
      },

      //编辑界面数据
      editForm: {},
      //编辑页面之前的数据
      //然后对比两个Form决定删除还是添加还是修改
      editBeforeForm: {},
      editRemoveItemForm: [],
      catOptions: [],
      copycatOptions: [],
    };
  },

  methods: {
     //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //修改
    guanliFix(idnex, row) {
      console.log(this.$refs["guanliTable"]);
      console.log(this.$refs["input"]);
    },
    //类别显示转换
    chooseCat(value) {
      console.log(value);
      this.currentTypeIndex = value;
      this.typeList = this.catOptions[value].cacBaseBigItemList;
      this.cacTypeId = this.catOptions[value].cacTypeId;
      this.catName = this.catOptions[value].name;
      this.listLoading = false;
      this.filters.type = this.catOptions[value].name;
      for (var i = 0; i < this.typeList.length; i++) {
        if (this.typeList[i].instruction != null) {
          this.typeList[i].typeName =
            this.typeList[i].name + ":  " + this.typeList[i].instruction;
        } else {
          this.typeList[i].typeName = this.typeList[i].name + ":  ";
        }
      }
    },
    selectedittype(selVal) {
      console.log(selVal);
      if (selVal == 1) {
        this.sumedittype = false;
        console.log(this.editForm.cacBaseMinorItemList);
        if (this.editForm.cacBaseMinorItemList.length != 0) {
          for (var i = 1; i < this.editForm.cacBaseMinorItemList.length; i++) {
            if (this.editForm.cacBaseMinorItemList[i].minorItemId != -1) {
              this.editRemoveItemForm.push({
                minorItemId: this.editForm.cacBaseMinorItemList[i].minorItemId,
              });
            }
          }
          this.editForm.cacBaseMinorItemList = [
            {
              minorItemId: this.editForm.cacBaseMinorItemList[0].minorItemId,
              grade: 0,
              bigItemId: this.editForm.bigItemId,
              name: this.editForm.cacBaseMinorItemList[0].name,
              instruction: this.editForm.cacBaseMinorItemList[0].instruction,
            },
          ];
        } else {
          this.editForm.cacBaseMinorItemList = [
            {
              minorItemId: 0,
              grade: 0,
              bigItemId: this.editForm.bigItemId,
              name: "",
              instruction: "",
            },
          ];
        }
        this.tenOptions = [
          {
            value: 0,
            label: "0分",
          },
        ];
      } else if (selVal == 2) {
        this.sumedittype = true;
        for (var i = 0; i < this.editForm.cacBaseMinorItemList.length; i++) {
          if (this.editForm.cacBaseMinorItemList[i].grade > 5) {
            this.editForm.cacBaseMinorItemList[i].grade = "";
          }
        }
        this.tenOptions = [
          {
            value: 0,
            label: "0",
          },
          {
            value: 1,
            label: "1",
          },
          {
            value: 2,
            label: "2",
          },
          {
            value: 3,
            label: "3",
          },
          {
            value: 4,
            label: "4",
          },
          {
            value: 5,
            label: "5",
          },
        ];
      } else {
        this.sumedittype = true;
        this.tenOptions = this.holdtenoption;
      }
    },
    selecttype(selVal) {
      console.log(selVal);
      if (selVal == 1) {
        this.sumtype = false;
        console.log(this.addTypeItemForm.addTypeItems);
        this.addTypeItemForm.addTypeItems = [
          {
            grade: 0,
            name: "",
            instruction: "",
          },
        ];
        this.tenOptions = [
          {
            value: 0,
            label: "0分",
          },
        ];
      } else if (selVal == 2) {
        this.sumtype = true;
        for (var i = 0; i < this.addTypeItemForm.addTypeItems.length; i++) {
          if (this.addTypeItemForm.addTypeItems[i].grade > 5) {
            this.addTypeItemForm.addTypeItems[i].grade = "";
          }
        }
        this.tenOptions = [
          {
            value: 0,
            label: "0",
          },
          {
            value: 1,
            label: "1",
          },
          {
            value: 2,
            label: "2",
          },
          {
            value: 3,
            label: "3",
          },
          {
            value: 4,
            label: "4",
          },
          {
            value: 5,
            label: "5",
          },
        ];
      } else {
        this.sumtype = true;
        this.tenOptions = this.holdtenoption;
      }
    },
    //获取类别列表
    getSelectList() {
      console.log("========");
      this.listLoading = true;
      this.$postForm("cac/CacBaseType/selectBaseShowAll", {}).then((res) => {
        console.log(res);
        this.catOptions = res.result;
        this.listLoading = false;
        if (res.result != null && res.result.length != 0) {
          this.catName = res.result[this.currentTypeIndex].name;
          this.typeList = res.result[this.currentTypeIndex].cacBaseBigItemList;
          this.cacTypeId = res.result[this.currentTypeIndex].cacTypeId;
          this.filters.type = res.result[this.currentTypeIndex].name;
          for (var i = 0; i < this.typeList.length; i++) {
            if (this.typeList[i].instruction != null) {
              this.typeList[i].typeName =
                this.typeList[i].name + ":  " + this.typeList[i].instruction;
            } else {
              this.typeList[i].typeName = this.typeList[i].name + ":  ";
            }
          }
        }
      });
    },
    //添加类别模块
    addCata: function () {
      this.addCatVisible = true;
      this.addCataForm = {
        name: "",
      };
      this.$nextTick(() => {
        this.$refs["addCataForm"].resetFields();
      });
      console.log(this.catOptions.length);
    },
    cancelCataSubmit: function () {
      this.$refs["addCataForm"].resetFields();
      this.addCatVisible = false;
    },
    addCataSubmit: function () {
      //新添类别
      // replace(/\s/g,"")
      if (this.addCataForm.name.replace(/\s/g, "") == "") {
        this.$message.error("类别名称不能为空");
        return;
      }
      if (this.catOptions != null && this.catOptions.length == 4) {
        this.$message.error("评估只能是四项,不能再添加了");
        return;
      }
      let para = Object.assign({}, this.addCataForm);
      var qs = require("querystring");
      this.$postForm("cac/CacBaseType/addCacBaseType", para).then((res) => {
        console.log(res);
        this.editLoading = false;
        if (res.code == 200) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.$refs["addCataForm"].resetFields();
          this.addCatVisible = false;
          this.getSelectList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //管理模块
    deleteCata: function () {
      this.guanliDialogVisible = true;
      this.copycatOptions = [];
      for (var i = 0; i < this.catOptions.length; i++) {
        this.copycatOptions.push(Object.assign({}, this.catOptions[i]));
      }
      console.log(this.copycatOptions);
    }, //修改
    guanliEdit: function (index, row) {
      if (row.name.replace(/\s/g, "") == "") {
        this.$message.error("类别名称不能为空");
        return;
      }
      var right = [];
      this.copycatOptions.forEach((item) => {
        let para = Object.assign(
          {},
          {
            cacTypeId: item.cacTypeId,
            name: item.name,
          }
        );
        this.$postForm("cac/CacBaseType/updateCacBaseType", para).then(
          (res) => {
            this.editLoading = false;
            if (res.code == 200) {
              right.push("yes");
            } else {
              this.$message.error(res.message);
            }
          }
        );
      });
      setTimeout(() => {
        if (right.length > 0) {
          this.$message({ message: "修改成功", type: "success" });
          this.guanliDialogVisible = false;
          this.getSelectList();
        }
      }, 1000);
    }, //删除
    guanliDel: function (index, row) {
      //
      this.$confirm("确认删除该类别吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          let para = Object.assign(
            {},
            {
              cacTypeId: row.cacTypeId,
            }
          );
          this.$postForm("cac/CacBaseType/delCacBaseType", para).then((res) => {
            this.editLoading = false;
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getSelectList();
              this.guanliDialogVisible = false;
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    //添加项目
    addType: function () {
      this.addTypeVisible = true;

      this.addTypeForm = {
        name: "", //项目名称
        instruction: "", //描述
        type: "", //表明类别
      };
      this.addTypeItemForm = {
        addTypeItems: [
          {
            grade: "",
            name: "",
            instruction: "",
          },
        ],
      };

      this.$nextTick(() => {
        this.$refs["addTypeForm"].resetFields();
        this.$refs["addTypeItemForm"].resetFields();
      });
    },
    addTypeItem: function () {
      this.addTypeItemForm.addTypeItems.push({
        grade: "",
        name: "",
        instruction: "",
      });
    },
    deleteTypeItemindex: function (index) {
      this.addTypeItemForm.addTypeItems.splice(index, 1);
    },
    cancelTypeSubmit: function () {
      this.addTypeVisible = false;
      this.$refs["addTypeForm"].resetFields();
    },
    addTypeSubmit: function () {
      console.log(this.addTypeForm);
      this.addTypeForm.name = this.addTypeForm.name.replace(/\s+/g, "");
      if (
        this.addTypeForm.name === "" ||
        this.addTypeForm.name.replace(/\s+/g, "") === ""
      ) {
        this.$message.error("评估项目不能为空");
        return;
      }
      //by guo  2019-3-28  修改
      // if (this.addTypeForm.instruction === '' || this.addTypeForm.instruction.replace(/\s+/g, "") === '') {
      //   this.$message.error('项目说明不能为空');
      //   return;
      // }
      if (this.addTypeForm.type === "") {
        this.$message.error("项目类别不能为空");
        return;
      }

      if (
        this.addTypeItemForm.addTypeItems == null ||
        this.addTypeItemForm.addTypeItems.length == 0
      ) {
        this.$message.error("小项不能为空");
        return;
      }
      for (var i = 0; i < this.addTypeItemForm.addTypeItems.length; i++) {
        if (this.addTypeItemForm.addTypeItems[i].grade === "") {
          this.$message.error("小项分数不能为空");
          return;
        }
        if (
          this.addTypeItemForm.addTypeItems[i].name.replace(/\s+/g, "") === ""
        ) {
          this.$message.error("小项名称不能为空");
          return;
        }
        for (var j = 0; j < i; j++) {
          if (
            this.addTypeItemForm.addTypeItems[i].name.replace(/\s+/g, "") ==
            this.addTypeItemForm.addTypeItems[j].name.replace(/\s+/g, "")
          ) {
            this.$message.error("小项名称不能重复");
            return;
          }
          if (
            this.addTypeItemForm.addTypeItems[i].grade ==
            this.addTypeItemForm.addTypeItems[j].grade
          ) {
            this.$message.error("小项分数不能重复");
            return;
          }
        }
      }
      this.addTypeForm.cacTypeId = this.cacTypeId;
      this.addTypeForm.cacBaseMinorItemList = this.addTypeItemForm.addTypeItems;
      console.log(this.addTypeForm);
      let para = Object.assign({}, this.addTypeForm);

      this.$postJson("cac/CacBaseBigItem/addCacBaseBigItems", para).then(
        (res) => {
          if (res.code == 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.addTypeVisible = false;
            this.$refs["addTypeForm"].resetFields();
            this.getSelectList();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    addTypeBig: function () {
      this.addTypeForm.cacTypeId = this.cacTypeId;
      let para = Object.assign({}, this.addTypeForm);
      this.$postForm("cac/CacBaseBigItem/addCacBaseBigItem", para).then(
        (res) => {
          if (res.code == 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$refs["addTypeForm"].resetFields();
            this.getSelectList();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    handleDetail: function (index, row) {
      var id = row.oldmanId;
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm("确认删除该项吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
        center:true
      })
        .then(() => {
          let para = { bigItemId: row.bigItemId };
          this.$postForm("cac/CacBaseBigItem/delCacBaseBigItem", para).then(
            (res) => {
              if (res.code == 200) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getSelectList();
              } else {
                this.$message.error(res.message);
              }
            }
          );
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;

      this.editForm = Object.assign({}, row);

      this.$nextTick(() => {
        this.$refs["editForm"].clearValidate();
        this.$refs["editForm1"].clearValidate();
      });
      //bug copy的时候未把里面的object也copy,需要再一个个copy
      this.editForm.cacBaseMinorItemList = [];
      for (var i = 0; i < row.cacBaseMinorItemList.length; i++) {
        this.editForm.cacBaseMinorItemList.push(
          Object.assign({}, row.cacBaseMinorItemList[i])
        );
      }

      //保存原来的值,然后通过对比值的改变来调用修改接口和添加接口
      this.editBeforeForm = Object.assign({}, row);
      this.editBeforeForm.cacBaseMinorItemList = [];
      for (var i = 0; i < row.cacBaseMinorItemList.length; i++) {
        this.editBeforeForm.cacBaseMinorItemList.push(
          Object.assign({}, row.cacBaseMinorItemList[i])
        );
      }
      //保存删除的项
      this.editRemoveItemForm = [];
      console.log(this.editForm);
      if (this.editForm.type == 0) {
        this.sumedittype = true;
        this.tenOptions = this.holdtenoption;
      } else if (this.editForm.type == 1) {
        this.sumedittype = false;
        this.tenOptions = [
          {
            value: 0,
            label: "0分",
          },
        ];
      } else {
        this.sumedittype = true;
        this.tenOptions = [
          {
            value: 0,
            label: "0",
          },
          {
            value: 1,
            label: "1",
          },
          {
            value: 2,
            label: "2",
          },
          {
            value: 3,
            label: "3",
          },
          {
            value: 4,
            label: "4",
          },
          {
            value: 5,
            label: "5",
          },
        ];
      }
    },
    deleteEditTypeItemindex: function (index, item) {
      //调删除item接口
      this.editForm.cacBaseMinorItemList.splice(index, 1);
      if (item.minorItemId != -1) {
        this.editRemoveItemForm.push({
          minorItemId: item.minorItemId,
        });
      }
    },
    addEditTypeItem: function () {
      this.editForm.cacBaseMinorItemList.push({
        minorItemId: 0,
        grade: "",
        bigItemId: this.editForm.bigItemId,
        name: "",
        instruction: "",
      });
    },
    //编辑
    editSubmit: function () {
      var editOnFlag = false;
      this.editFormVisible = false;
      if (
        this.editForm.name == this.editBeforeForm.name &&
        this.editForm.instruction == this.editBeforeForm.instruction &&
        this.editForm.type == this.editBeforeForm.type
      ) {
        //大的没有改动
        if (
          this.editForm.cacBaseMinorItemList == null ||
          this.editForm.cacBaseMinorItemList.length == 0
        ) {
          this.$message.error("小项不能为空");
          return;
        }
        for (var i = 0; i < this.editForm.cacBaseMinorItemList.length; i++) {
          var info = {
            name: this.editForm.cacBaseMinorItemList[i].name,
            grade: this.editForm.cacBaseMinorItemList[i].grade,
          };
          if (
            this.editForm.cacBaseMinorItemList[i].name.replace(/\s/g, "") === ""
          ) {
            this.$message.error("小项名称不能为空");
            return;
          }
          if (this.editForm.cacBaseMinorItemList[i].grade === "") {
            this.$message.error("小项分数不能为空");
            return;
          }
          for (var j = 0; j < i; j++) {
            if (
              this.editForm.cacBaseMinorItemList[i].name.replace(/\s+/g, "") ==
              this.editForm.cacBaseMinorItemList[j].name.replace(/\s+/g, "")
            ) {
              this.$message.error("小项名称不能重复");
              return;
            }
            if (
              this.editForm.cacBaseMinorItemList[i].grade ==
              this.editForm.cacBaseMinorItemList[j].grade
            ) {
              this.$message.error("小项分数不能重复");
              return;
            }
          }
        }

        //删除Item
        for (var k = 0; k < this.editRemoveItemForm.length; k++) {
          var info = {
            minorItemId: this.editRemoveItemForm[k].minorItemId,
          };
          if (info.minorItemId != 0) {
            let para = Object.assign({}, info);
            this.$postForm(
              "cac/CacBaseMinorItem/delCacBaseMinorItem",
              para
            ).then((res) => {
              if (res.code == 200) {
                if (!editOnFlag) {
                  editOnFlag = true;
                  this.editFormVisible = false;
                  this.$message({
                    message: "修改成功",
                    type: "success",
                  });
                }
                this.getSelectList();
              } else {
                this.$message.error(res.message);
                this.editFormVisible = false;
              }
            });
          }
        }

        for (var i = 0; i < this.editForm.cacBaseMinorItemList.length; i++) {
          if (this.editForm.cacBaseMinorItemList[i].minorItemId === 0) {
            //新添的项
            var info = {
              name: this.editForm.cacBaseMinorItemList[i].name,
              instruction: this.editForm.cacBaseMinorItemList[i].instruction,
              grade: this.editForm.cacBaseMinorItemList[i].grade,
              bigItemId: this.editForm.cacBaseMinorItemList[i].bigItemId,
            };
            let para = Object.assign({}, info);
            console.log(para);
            this.$postForm(
              "cac/CacBaseMinorItem/addCacBaseMinorItem",
              para
            ).then((res) => {
              if (res.code == 200) {
                if (!editOnFlag) {
                  editOnFlag = true;
                  this.editFormVisible = false;
                  this.$message({
                    message: "修改成功",
                    type: "success",
                  });
                }
                this.getSelectList();
              } else {
                this.$message.error(res.message);
                this.editFormVisible = false;
              }
            });
          } else {
            for (
              var j = 0;
              j < this.editBeforeForm.cacBaseMinorItemList.length;
              j++
            ) {
              if (
                this.editForm.cacBaseMinorItemList[i].minorItemId ==
                this.editBeforeForm.cacBaseMinorItemList[j].minorItemId
              ) {
                if (
                  this.editForm.cacBaseMinorItemList[i].name ==
                    this.editBeforeForm.cacBaseMinorItemList[j].name &&
                  this.editForm.cacBaseMinorItemList[i].instruction ==
                    this.editBeforeForm.cacBaseMinorItemList[j].instruction &&
                  this.editForm.cacBaseMinorItemList[i].grade ==
                    this.editBeforeForm.cacBaseMinorItemList[j].grade
                ) {
                  //没有编辑
                  //不改动
                } else {
                  var info = {
                    minorItemId:
                      this.editForm.cacBaseMinorItemList[i].minorItemId,
                    name: this.editForm.cacBaseMinorItemList[i].name,
                    instruction:
                      this.editForm.cacBaseMinorItemList[i].instruction,
                    grade: this.editForm.cacBaseMinorItemList[i].grade,
                    bigItemId: this.editForm.cacBaseMinorItemList[i].bigItemId,
                  };
                  let para = Object.assign({}, info);
                  console.log(para);
                  this.$postForm(
                    "cac/CacBaseMinorItem/updateCacBaseMinorItem",
                    para
                  ).then((res) => {
                    if (res.code == 200) {
                      if (!editOnFlag) {
                        editOnFlag = true;
                        this.editFormVisible = false;
                        this.$message({
                          message: "修改成功",
                          type: "success",
                        });
                      }
                      this.getSelectList();
                    } else {
                      this.$message.error(res.message);
                      this.editFormVisible = false;
                    }
                  });
                }
                break;
              }
            }
          }
        }
      } else {
        //名称等改变了,,则进行这个
        var info = {
          bigItemId: this.editForm.bigItemId,
          cacTypeId: this.editForm.cacTypeId,
          name: this.editForm.name,
          instruction: this.editForm.instruction,
          type: this.editForm.type,
        };
        if (this.editForm.name.replace(/\s+/g, "") === "") {
          this.$message.error("评估项目不能为空");
          return;
        }
        //by guo 2019-3-28 修改
        // if (this.editForm.instruction.replace(/\s+/g, "") === '') {
        //   this.$message.error('项目说明不能为空');
        //   return;
        // }
        if (this.editForm.type === "") {
          this.$message.error("项目类别不能为空");
          return;
        }
        if (
          this.editForm.cacBaseMinorItemList == null ||
          this.editForm.cacBaseMinorItemList.length == 0
        ) {
          this.$message.error("小项不能为空");
          return;
        }

        console.log(this.editForm.cacBaseMinorItemList);

        for (var i = 0; i < this.editForm.cacBaseMinorItemList.length; i++) {
          if (
            this.editForm.cacBaseMinorItemList[i].name.replace(/\s/g, "") === ""
          ) {
            this.$message.error("小项名称不能为空");
            return;
          }
          if (this.editForm.cacBaseMinorItemList[i].grade === "") {
            this.$message.error("小项分数不能为空");
            return;
          }

          for (var j = 0; j < i; j++) {
            if (
              this.editForm.cacBaseMinorItemList[i].name.replace(/\s+/g, "") ==
              this.editForm.cacBaseMinorItemList[j].name.replace(/\s+/g, "")
            ) {
              this.$message.error("小项名称不能重复");
              return;
            }
            if (
              this.editForm.cacBaseMinorItemList[i].grade ==
              this.editForm.cacBaseMinorItemList[j].grade
            ) {
              this.$message.error("小项分数不能重复");
              return;
            }
          }
        }
        let para = Object.assign({}, info);
        console.log(para);
        this.$postForm("cac/CacBaseBigItem/updateCacBaseBigItem", para).then(
          (res) => {
            if (res.code == 200) {
              if (!editOnFlag) {
                editOnFlag = true;
                this.editFormVisible = false;
                this.$message({
                  message: "修改成功",
                  type: "success",
                });

                //删除Item
                for (var k = 0; k < this.editRemoveItemForm.length; k++) {
                  var info = {
                    minorItemId: this.editRemoveItemForm[k].minorItemId,
                  };
                  if (info.minorItemId != 0) {
                    let para = Object.assign({}, info);
                    this.$postForm(
                      "cac/CacBaseMinorItem/delCacBaseMinorItem",
                      para
                    ).then((res) => {
                      if (res.code == 200) {
                        if (!editOnFlag) {
                          editOnFlag = true;
                          this.editFormVisible = false;
                          this.$message({
                            message: "修改成功",
                            type: "success",
                          });
                        }
                        this.getSelectList();
                      } else {
                        this.$message.error(res.message);
                      }
                    });
                  }
                }

                for (
                  var i = 0;
                  i < this.editForm.cacBaseMinorItemList.length;
                  i++
                ) {
                  if (this.editForm.cacBaseMinorItemList[i].minorItemId === 0) {
                    //新添的项
                    var info = {
                      name: this.editForm.cacBaseMinorItemList[i].name,
                      instruction:
                        this.editForm.cacBaseMinorItemList[i].instruction,
                      grade: this.editForm.cacBaseMinorItemList[i].grade,
                      bigItemId:
                        this.editForm.cacBaseMinorItemList[i].bigItemId,
                    };
                    let para = Object.assign({}, info);
                    this.$postForm(
                      "cac/CacBaseMinorItem/addCacBaseMinorItem",
                      para
                    ).then((res) => {
                      if (res.code == 200) {
                        if (!editOnFlag) {
                          editOnFlag = true;
                          this.editFormVisible = false;
                          this.$message({
                            message: "修改成功",
                            type: "success",
                          });
                        }
                        this.getSelectList();
                      } else {
                        this.$message.error(res.message);
                      }
                    });
                  } else {
                    for (
                      var j = 0;
                      j < this.editBeforeForm.cacBaseMinorItemList.length;
                      j++
                    ) {
                      if (
                        this.editForm.cacBaseMinorItemList[i].minorItemId ==
                        this.editBeforeForm.cacBaseMinorItemList[j].minorItemId
                      ) {
                        if (
                          this.editForm.cacBaseMinorItemList[i].name ==
                            this.editBeforeForm.cacBaseMinorItemList[j].name &&
                          this.editForm.cacBaseMinorItemList[i].instruction ==
                            this.editBeforeForm.cacBaseMinorItemList[j]
                              .instruction &&
                          this.editForm.cacBaseMinorItemList[i].grade ==
                            this.editBeforeForm.cacBaseMinorItemList[j].grade
                        ) {
                          //没有编辑
                          //不改动
                        } else {
                          var info = {
                            minorItemId:
                              this.editForm.cacBaseMinorItemList[i].minorItemId,
                            name: this.editForm.cacBaseMinorItemList[i].name,
                            instruction:
                              this.editForm.cacBaseMinorItemList[i].instruction,
                            grade: this.editForm.cacBaseMinorItemList[i].grade,
                            bigItemId:
                              this.editForm.cacBaseMinorItemList[i].bigItemId,
                          };
                          let para = Object.assign({}, info);
                          this.$postForm(
                            "cac/CacBaseMinorItem/updateCacBaseMinorItem",
                            para
                          ).then((res) => {
                            if (res.code == 200) {
                              if (!editOnFlag) {
                                editOnFlag = true;
                                this.editFormVisible = false;
                                this.$message({
                                  message: "修改成功",
                                  type: "success",
                                });
                              }
                              this.getSelectList();
                            } else {
                              this.$message.error(res.message);
                            }
                          });
                        }
                        break;
                      }
                    }
                  }
                }
              }
              this.getSelectList();
            } else {
              this.editFormVisible = false;
              this.$message.error(res.message);
            }
          }
        );
      }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
  },
  mounted() {
    this.getSelectList();
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1100px) and (max-width: 1400px) {
  ::deep .addTypeVisible .el-dialog {
    width: 80% !important;
  }
}
@media screen and (min-width: 1401px) {
  ::deep .addTypeVisible .el-dialog {
    width: 50% !important;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1400px) {
  ::deep .editFormVisible .el-dialog {
    width: 80% !important;
  }
}
@media screen and (min-width: 1401px) {
  ::deep .editFormVisible .el-dialog {
    width: 50% !important;
  }
}
.el-form-item__error {
  white-space: nowrap;
}

//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>
